import { GaugeDial } from "@/src/components/GaugeDial";
import { I18nUtil } from "@utils/i18n";
import React from "react";
import Translations from "@translate/components/Home/MarketIndicators/FearGreedGauge/FearGreedGauge";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface FearGreedGaugeProps {
  /** 当前值 (0-100) */
  value: number;
  /** 标题 */
  title?: string;
  /** 自定义类名 */
  className?: string;
  /** 标题自定义类名 */
  titleClassName?: string;
  /** 状态自定义类名 */
  statusClassName?: string;
  /** 仪表盘宽度（支持数字、百分比、calc等CSS值） */
  width?: number | string;
}

/**
 * Fear & Greed Index 仪表盘组件
 * 显示一个半圆形的仪表盘，带有渐变色圆弧
 */
export const FearGreedGauge: React.FC<FearGreedGaugeProps> = ({
  value,
  title = I18n.t("Fear & Greed Index"),
  className,
  titleClassName,
  statusClassName,
  width: propWidth,
}) => {
  // 确保值在 0-100 范围内
  const normalizedValue = Math.max(0, Math.min(100, value));

  // 根据值判断状态
  const getStatus = (val: number) => {
    if (val < 25) {
      return I18n.t("Extreme Fear");
    }
    if (val < 50) {
      return I18n.t("Fear");
    }
    if (val < 55) {
      return I18n.t("Neutral");
    }
    if (val < 75) {
      return I18n.t("Greed");
    }
    if (val < 100) {
      return I18n.t("Extreme Greed");
    }
    return I18n.t("Extreme Greed");
  };

  const status = getStatus(normalizedValue);

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      {/* 标题 */}
      <h3
        aria-label="Fear Greed Gauge h3"
        data-openreplay-label="Fear Greed Gauge h3 Semantic"
        id="sem-fear-greed-gauge-h3"
        className={cn(
          "title_l text-content_primary hidden md:block",
          titleClassName,
        )}
      >
        {title}
      </h3>

      <div className="flex items-center justify-between gap-[5px]">
        {/* 左侧数值显示 */}
        <div className="flex flex-col gap-2">
          <h3
            aria-label="Fear Greed Gauge h3"
            data-openreplay-label="Fear Greed Gauge h3 Semantic"
            id="sem-fear-greed-gauge-h3-2"
            className={cn(
              "title_l text-content_primary md:hidden block",
              titleClassName,
            )}
          >
            {title}
          </h3>
          <div className="flex md:flex-col flex-row gap-[6px] md:gap-0 items-end md:items-start">
            <div className="headline_regular_s md:headline_regular_m text-content_primary">
              {normalizedValue}
            </div>
            <div
              className={cn("body_m text-content_secondary", statusClassName)}
            >
              {status}
            </div>
          </div>
        </div>

        {/* 右侧仪表盘 */}
        <GaugeDial value={normalizedValue} width={propWidth} />
      </div>
    </div>
  );
};
